import { createAction, props } from '@ngrx/store';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { IDataAction } from '../../utils/interfaces/common.interfaces';
import { Report } from '../../generated/CrossPoint.Analytics.Server/model/report';
import { AllTierLimits, DemoCount, DemoRetailer, Locale, ReportFtpSettings, ReportHttpSettings, ReportPreview, ReportS3Settings, ReportSftpSettings, RetailerLicenseState, TimeZone } from 'src/app/generated/CrossPoint.Analytics.Server';
import { DetailedXpacInfo } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { IGetReports, IGetMatchingStores, ICreateReport, IUpdateReport, ICalculateReportRegeneration, IDeleteReport, ICreateDemo } from 'src/app/utils/interfaces/analytics.interface';

export enum AnalyticsActionsTypes {
  GET_AUTH_INFO_ANALYTICS = '[ANALYTICS] GET_AUTH_INFO_ANALYTICS',
  GET_AUTH_INFO_ANALYTICS_SUCCESS = '[ANALYTICS] GET_AUTH_INFO_ANALYTICS_SUCCESS',
  GET_AUTH_INFO_ANALYTICS_FAILED = '[ANALYTICS] GET_AUTH_INFO_ANALYTICS_FAILED',

  GET_REPORTS_ANALYTICS = '[ANALYTICS] GET_REPORTS_ANALYTICS',
  GET_REPORTS_ANALYTICS_SUCCESS = '[ANALYTICS] GET_REPORTS_ANALYTICS_SUCCESS',
  GET_REPORTS_ANALYTICS_FAILED = '[ANALYTICS] GET_REPORTS_ANALYTICS_FAILED',

  CALCULATE_REPORT_REGENERATION_ANALYTICS = '[ANALYTICS] CALCULATE_REPORT_REGENERATION_ANALYTICS',
  CALCULATE_REPORT_REGENERATION_ANALYTICS_SUCCESS = '[ANALYTICS] CALCULATE_REPORT_REGENERATION_ANALYTICS_SUCCESS',
  CALCULATE_REPORT_REGENERATION_ANALYTICS_FAILED = '[ANALYTICS] CALCULATE_REPORT_REGENERATION_ANALYTICS_FAILED',

  REGENERATE_REPORT_ANALYTICS = '[ANALYTICS] REGENERATE_REPORT_ANALYTICS',
  REGENERATE_REPORT_ANALYTICS_SUCCESS = '[ANALYTICS] REGENERATE_REPORT_ANALYTICS_SUCCESS',
  REGENERATE_REPORT_ANALYTICS_FAILED = '[ANALYTICS] REGENERATE_REPORT_ANALYTICS_FAILED',

  GET_MATCHING_STORES = '[ANALYTICS] GET_MATCHING_STORES',
  GET_MATCHING_STORES_SUCCESS = '[ANALYTICS] GET_MATCHING_STORES_SUCCESS',
  GET_MATCHING_STORES_FAILED = '[ANALYTICS] GET_MATCHING_STORES_FAILED',

  CREATE_REPORT = '[ANALYTICS] CREATE_REPORT',
  CREATE_REPORT_SUCCESS = '[ANALYTICS] CREATE_REPORT_SUCCESS',
  CREATE_REPORT_FAILED = '[ANALYTICS] CREATE_REPORT_FAILED',

  UPDATE_REPORT = '[ANALYTICS] UPDATE_REPORT',
  UPDATE_REPORT_SUCCESS = '[ANALYTICS] UPDATE_REPORT_SUCCESS',
  UPDATE_REPORT_FAILED = '[ANALYTICS] UPDATE_REPORT_FAILED',

  DELETE_REPORT = '[ANALYTICS] DELETE_REPORT',
  DELETE_REPORT_SUCCESS = '[ANALYTICS] DELETE_REPORT_SUCCESS',
  DELETE_REPORT_FAILED = '[ANALYTICS] DELETE_REPORT_FAILED',

  GET_TIMEZONES_ANALYTICS = '[ANALYTICS] GET_TIMEZONES_ANALYTICS',
  GET_TIMEZONES_ANALYTICS_SUCCESS = '[ANALYTICS] GET_TIMEZONES_ANALYTICS_SUCCESS',
  GET_TIMEZONES_ANALYTICS_FAILED = '[ANALYTICS] GET_TIMEZONES_ANALYTICS_FAILED',

  GET_LOCALES = '[ANALYTICS] GET_LOCALES',
  GET_LOCALES_SUCCESS = '[ANALYTICS] GET_LOCALES_SUCCESS',
  GET_LOCALES_FAILED = '[ANALYTICS] GET_LOCALES_FAILED',

  TEST_FTP_SETTINGS = '[ANALYTICS] TEST_FTP_SETTINGS',
  TEST_FTP_SETTINGS_SUCCESS = '[ANALYTICS] TEST_FTP_SETTINGS_SUCCESS',
  TEST_FTP_SETTINGS_FAILED = '[ANALYTICS] TEST_FTP_SETTINGS_FAILED',

  TEST_SFTP_SETTINGS = '[ANALYTICS] TEST_SFTP_SETTINGS',
  TEST_SFTP_SETTINGS_SUCCESS = '[ANALYTICS] TEST_SFTP_SETTINGS_SUCCESS',
  TEST_SFTP_SETTINGS_FAILED = '[ANALYTICS] TEST_SFTP_SETTINGS_FAILED',

  TEST_S3_SETTINGS = '[ANALYTICS] TEST_S3_SETTINGS',
  TEST_S3_SETTINGS_SUCCESS = '[ANALYTICS] TEST_S3_SETTINGS_SUCCESS',
  TEST_S3_SETTINGS_FAILED = '[ANALYTICS] TEST_S3_SETTINGS_FAILED',

  TEST_HTTP_SETTINGS = '[ANALYTICS] TEST_HTTP_SETTINGS',
  TEST_HTTP_SETTINGS_SUCCESS = '[ANALYTICS] TEST_HTTP_SETTINGS_SUCCESS',
  TEST_HTTP_SETTINGS_FAILED = '[ANALYTICS] TEST_HTTP_SETTINGS_FAILED',

  GET_RETAILER_LICENSE = '[ANALYTICS] GET_RETAILER_LICENSE',
  GET_RETAILER_LICENSE_SUCCESS = '[ANALYTICS] GET_RETAILER_LICENSE_SUCCESS',
  GET_RETAILER_LICENSE_FAILED = '[ANALYTICS] GET_RETAILER_LICENSE_FAILED',

  GET_TIER_LIMITS = '[ANALYTICS] GET_TIER_LIMITS',
  GET_TIER_LIMITS_SUCCESS = '[ANALYTICS] GET_TIER_LIMITS_SUCCESS',
  GET_TIER_LIMITS_FAILED = '[ANALYTICS] GET_TIER_LIMITS_FAILED',

  CREATE_DEMO_RETAILER = '[ANALYTICS] CREATE_DEMO_RETAILER',
  CREATE_DEMO_RETAILER_SUCCESS = '[ANALYTICS] CREATE_DEMO_RETAILER_SUCCESS',
  CREATE_DEMO_RETAILER_FAILED = '[ANALYTICS] CREATE_DEMO_RETAILER_FAILED',

  GET_DEMO_STATISTICS = '[ANALYTICS] GET_DEMO_STATISTICS',
  GET_DEMO_STATISTICS_SUCCESS = '[ANALYTICS] GET_DEMO_STATISTICS_SUCCESS',
  GET_DEMO_STATISTICS_FAILED = '[ANALYTICS] GET_DEMO_STATISTICS_FAILED',
}

export const getAuthInfoAnalyticsAction = createAction(AnalyticsActionsTypes.GET_AUTH_INFO_ANALYTICS);
export const getAuthInfoAnalyticsSuccessAction = createAction(AnalyticsActionsTypes.GET_AUTH_INFO_ANALYTICS_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoAnalyticsFailedAction = createAction(AnalyticsActionsTypes.GET_AUTH_INFO_ANALYTICS_FAILED);

export const getReportsAction = createAction(AnalyticsActionsTypes.GET_REPORTS_ANALYTICS, props<IDataAction<IGetReports>>());
export const getReportsSuccessAction = createAction(AnalyticsActionsTypes.GET_REPORTS_ANALYTICS_SUCCESS, props<IDataAction<Report[]>>());
export const getReportsFailedAction = createAction(AnalyticsActionsTypes.GET_REPORTS_ANALYTICS_FAILED);

export const calculateReportRegenerationAction = createAction(AnalyticsActionsTypes.CALCULATE_REPORT_REGENERATION_ANALYTICS, props<IDataAction<ICalculateReportRegeneration>>());
export const calculateReportRegenerationSuccessAction = createAction(AnalyticsActionsTypes.CALCULATE_REPORT_REGENERATION_ANALYTICS_SUCCESS, props<IDataAction<ReportPreview>>());
export const calculateReportRegenerationFailedAction = createAction(AnalyticsActionsTypes.CALCULATE_REPORT_REGENERATION_ANALYTICS_FAILED, props<IDataAction<string>>());

export const regenerateReportAction = createAction(AnalyticsActionsTypes.REGENERATE_REPORT_ANALYTICS, props<IDataAction<ICalculateReportRegeneration>>());
export const regenerateReportSuccessAction = createAction(AnalyticsActionsTypes.REGENERATE_REPORT_ANALYTICS_SUCCESS);
export const regenerateReportFailedAction = createAction(AnalyticsActionsTypes.REGENERATE_REPORT_ANALYTICS_FAILED);

export const getMatchingStoresAction = createAction(AnalyticsActionsTypes.GET_MATCHING_STORES, props<IDataAction<IGetMatchingStores>>());
export const getMatchingStoresSuccessAction = createAction(AnalyticsActionsTypes.GET_MATCHING_STORES_SUCCESS, props<IDataAction<DetailedXpacInfo[]>>());
export const getMatchingStoresFailedAction = createAction(AnalyticsActionsTypes.GET_MATCHING_STORES_FAILED);

export const createReportAction = createAction(AnalyticsActionsTypes.CREATE_REPORT, props<IDataAction<ICreateReport>>());
export const createReportSuccessAction = createAction(AnalyticsActionsTypes.CREATE_REPORT_SUCCESS, props<IDataAction<Report>>());
export const createReportFailedAction = createAction(AnalyticsActionsTypes.CREATE_REPORT_FAILED);

export const updateReportAction = createAction(AnalyticsActionsTypes.UPDATE_REPORT, props<IDataAction<IUpdateReport>>());
export const updateReportSuccessAction = createAction(AnalyticsActionsTypes.UPDATE_REPORT_SUCCESS, props<IDataAction<Report>>());
export const updateReportFailedAction = createAction(AnalyticsActionsTypes.UPDATE_REPORT_FAILED);

export const deleteReportAction = createAction(AnalyticsActionsTypes.DELETE_REPORT, props<IDataAction<IDeleteReport>>());
export const deleteReportSuccessAction = createAction(AnalyticsActionsTypes.DELETE_REPORT_SUCCESS, props<IDataAction<IDeleteReport>>());
export const deleteReportFailedAction = createAction(AnalyticsActionsTypes.DELETE_REPORT_FAILED);

export const getTimeZonesAction = createAction(AnalyticsActionsTypes.GET_TIMEZONES_ANALYTICS);
export const getTimeZonesSuccessAction = createAction(AnalyticsActionsTypes.GET_TIMEZONES_ANALYTICS_SUCCESS, props<IDataAction<TimeZone[]>>());
export const getTimeZonesFailedAction = createAction(AnalyticsActionsTypes.GET_TIMEZONES_ANALYTICS_SUCCESS);

export const getLocalesAction = createAction(AnalyticsActionsTypes.GET_LOCALES);
export const getLocalesSuccessAction = createAction(AnalyticsActionsTypes.GET_LOCALES_SUCCESS, props<IDataAction<Locale[]>>());
export const getLocalesFailedAction = createAction(AnalyticsActionsTypes.GET_LOCALES_FAILED);

export const testFtpSettingsAction = createAction(AnalyticsActionsTypes.TEST_FTP_SETTINGS, props<IDataAction<Required<ReportFtpSettings>>>());
export const testFtpSettingsSuccessAction = createAction(AnalyticsActionsTypes.TEST_FTP_SETTINGS_SUCCESS);
export const testFtpSettingsFailedAction = createAction(AnalyticsActionsTypes.TEST_FTP_SETTINGS_FAILED, props<IDataAction<string[]>>());

export const testSftpSettingsAction = createAction(AnalyticsActionsTypes.TEST_SFTP_SETTINGS, props<IDataAction<Required<ReportSftpSettings>>>());
export const testSftpSettingsSuccessAction = createAction(AnalyticsActionsTypes.TEST_SFTP_SETTINGS_SUCCESS);
export const testSftpSettingsFailedAction = createAction(AnalyticsActionsTypes.TEST_SFTP_SETTINGS_FAILED, props<IDataAction<string[]>>());

export const testS3SettingsAction = createAction(AnalyticsActionsTypes.TEST_S3_SETTINGS, props<IDataAction<Required<ReportS3Settings>>>());
export const testS3SettingsSuccessAction = createAction(AnalyticsActionsTypes.TEST_S3_SETTINGS_SUCCESS);
export const testS3SettingsFailedAction = createAction(AnalyticsActionsTypes.TEST_S3_SETTINGS_FAILED, props<IDataAction<string[]>>());

export const testHttpSettingsAction = createAction(AnalyticsActionsTypes.TEST_HTTP_SETTINGS, props<IDataAction<Required<ReportHttpSettings>>>());
export const testHttpSettingsSuccessAction = createAction(AnalyticsActionsTypes.TEST_HTTP_SETTINGS_SUCCESS);
export const testHttpSettingsFailedAction = createAction(AnalyticsActionsTypes.TEST_HTTP_SETTINGS_FAILED, props<IDataAction<string[]>>());

export const getRetailerLicenseAction = createAction(AnalyticsActionsTypes.GET_RETAILER_LICENSE, props<IDataAction<string>>());
export const getRetailerLicenseSuccessAction = createAction(AnalyticsActionsTypes.GET_RETAILER_LICENSE_SUCCESS, props<IDataAction<RetailerLicenseState>>());
export const getRetailerLicenseFailedAction = createAction(AnalyticsActionsTypes.GET_RETAILER_LICENSE_FAILED, props<IDataAction<string>>());

export const getTierLimitsAction = createAction(AnalyticsActionsTypes.GET_TIER_LIMITS);
export const getTierLimitsSuccessAction = createAction(AnalyticsActionsTypes.GET_TIER_LIMITS_SUCCESS, props<IDataAction<AllTierLimits>>());
export const getTierLimitsFailedAction = createAction(AnalyticsActionsTypes.GET_TIER_LIMITS_FAILED);

export const createDemoRetailerAction = createAction(AnalyticsActionsTypes.CREATE_DEMO_RETAILER, props<IDataAction<ICreateDemo>>());
export const createDemoRetailerSuccessAction = createAction(AnalyticsActionsTypes.CREATE_DEMO_RETAILER_SUCCESS, props<IDataAction<DemoRetailer>>());
export const createDemoRetailerFailedAction = createAction(AnalyticsActionsTypes.CREATE_DEMO_RETAILER_FAILED);

export const getDemoStatisticsAction = createAction(AnalyticsActionsTypes.GET_DEMO_STATISTICS);
export const getDemoStatisticsSuccessAction = createAction(AnalyticsActionsTypes.GET_DEMO_STATISTICS_SUCCESS, props<IDataAction<DemoCount>>());
export const getDemoStatisticsFailedAction = createAction(AnalyticsActionsTypes.GET_DEMO_STATISTICS_FAILED);